import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "vg_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export async function login(email, password) {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.access_token);
  return { ...data.user, must_change_password: !!data.must_change_password };
}

export async function changePassword(currentPassword, newPassword) {
  const { data } = await axios.post(`${API}/auth/change-password`,
    { current_password: currentPassword, new_password: newPassword }, { headers: authHeaders() });
  return data;
}

export async function fetchMe() {
  const { data } = await axios.get(`${API}/auth/me`, { headers: authHeaders() });
  return data;
}

export async function forgotPassword(email) {
  const { data } = await axios.post(`${API}/auth/forgot-password`, { email });
  return data;
}

export async function resetPassword(token, newPassword) {
  const { data } = await axios.post(`${API}/auth/reset-password`, { token, new_password: newPassword });
  return data;
}

export { API };
